/**
 * Phonics Letter Oo — 课程数据配置
 *
 * 课程结构：
 *   Step 1: Song/Chant — Letter Oo.mp4 (00:13 ~ 01:46)
 *   Step 2: 4格单词视频 — ostrich / ox / otter / octopus
 *   Step 3: Learn the Story (1) — 左上视频 + 右上单词(who/best/friend/good-better-best) + 下部2句故事
 *   Step 4: Learn the Story (2) — 视频在上，台词在下，只有英文配音
 *   Step 5: Learn the Story (3) — 视频在上，台词在下，只有英文配音
 *
 * Story 2/3：不要中文翻译，只有英文配音（用户要求）
 */

const MEDIA_BASE = '/media/phonics/oo';
const V = 'v1';

export const letterData = {
  letter: 'O',
  title: 'Phonics',
  subtitle: 'Letter Oo',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段 (Letter Oo.mp4, 00:13 ~ 01:46 = 13s ~ 106s)
  songVideo: {
    src: `${MEDIA_BASE}/Oo.mp4?${V}`,
    poster: `${MEDIA_BASE}/cover.png?${V}`,
    startTime: 13,
    endTime: 106,
  },

  // Step 2: 4格单词视频 (ostrich / ox / otter / octopus)
  // PPT: media2=ostrich(image8), media3=ox(image9), media4=otter(image10), media5=octopus(image11)
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
  ],

  // storySections
  storySections: [
    // Step 3: Learn the Story (1) — 左上视频 + 右上单词(4条) + 下部故事台词(2句)
    // splitAt=4: 前4条=右侧单词，后2条=视频下方故事句
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_story_oo1.mp4?${V}` }],
      splitAt: 4,
      lines: [
        // 右侧单词 (前 splitAt=4 条)
        { en: 'who', cn: '谁', audioEn: `${MEDIA_BASE}/w_en_who.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_who.mp3?${V}` },
        { en: 'best', cn: '最好的', audioEn: `${MEDIA_BASE}/w_en_best.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_best.mp3?${V}` },
        { en: 'friend', cn: '朋友', audioEn: `${MEDIA_BASE}/w_en_friend.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_friend.mp3?${V}` },
        { en: 'good → better → best', cn: '好 → 更好 → 最好', audioEn: `${MEDIA_BASE}/w_en_good_better_best.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_good_better_best.mp3?${V}`, cnNewLine: true },
        // 下部故事台词
        { en: 'Ostrich, who is your best friend?', cn: '鸵鸟，谁是你最好的朋友？', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}`, cnNewLine: true },
        { en: 'Ox is my best friend.', cn: '公牛是我最好的朋友。', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
      ],
    },

    // Step 4: Learn the Story (2) — 视频在上，台词在下，只有英文配音
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_oo2.mp4?${V}` }],
      lines: [
        { en: "Ox, who is your best friend?", audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}` },
        { en: "Otter is my best friend.", audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}` },
      ],
    },

    // Step 5: Learn the Story (3) — 视频在上，台词在下，只有英文配音
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_oo3.mp4?${V}` }],
      lines: [
        { en: "Otter, who is your best friend?", audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}` },
        { en: "Octopus is my best friend.", audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}` },
      ],
    },
  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图（AtoZ 封面）
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
